import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';

import { Card } from '../AllOffers/components/Card';
import { BonusType } from '@/api/cms/bonuses';
import { filterBonusesByGroups } from '@/helpers/bonuses';
import { useCommonStore } from '@/store';

import { ScAllOffers, ScCardRow } from './styled';

export const Sports = () => {
  const { t } = useTranslation('bonuses');
  const { user, pendingUser, cmsBonuses } = useCommonStore(
    useShallow((state) => ({
      user: state.user,
      pendingUser: state.pendingUser,
      cmsBonuses: state.cmsBonuses,
    }))
  );

  const selectedBonuses = useMemo(() => {
    if (pendingUser || !cmsBonuses) return [];
    return filterBonusesByGroups(
      cmsBonuses,
      'promoPageToggle',
      BonusType.SPORTS,
      user
    );
  }, [cmsBonuses, pendingUser, user]);

  return (
    <ScAllOffers>
      {selectedBonuses ? (
        <ScCardRow>
          {selectedBonuses.map((bonus) => (
            <Card key={bonus.id} {...bonus} />
          ))}
        </ScCardRow>
      ) : (
        <div className="no-offers">{t('tabs.empty')}</div>
      )}
    </ScAllOffers>
  );
};
